//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import List from './components/list';
export default {
  data() {
    return {
      activeType: 'system',
      showMap: {
        system: true,
      },
    };
  },
  components:{ List },
  methods: {
    tabChange() {
      this.$nextTick(()=>{
        this.$set(this.showMap, this.activeType, true);
      });
    },
  },
};
